module.exports = __webpack_public_path__ + "img/get_started.svg";